export const assetLibraryItems = [
  {
    title: "BV627 官方 Logo",
    description:
      "一张会自动宣布自己是画面主角的 PNG。放到哪里，哪里就会短暂拥有一种官方发布会正在酝酿的气氛。",
    downloadUrl: "https://vcos.vds.pub/vds-pub-fonts/assets-627/BV627.png"
  },
  {
    title: "BV627 品牌视频",
    description:
      "这段 MP4 的主要职责，是把带宽、视线和世界观同时卷进同一个漩涡里，然后一本正经地说这叫品牌表达。",
    downloadUrl: "https://vcos.vds.pub/vds-pub-fonts/assets-627/BV627.mp4"
  },
  {
    title: "BV627 开场音频",
    description:
      "如果你需要一种声音，能够让空气知道接下来不是普通开场而是 BV627 开场，那基本就是这一条了。",
    downloadUrl: "https://vcos.vds.pub/vds-pub-fonts/assets-627/opening.wav"
  }
];
